import React from 'react';
import { FadeIn } from './FadeIn';
const levels = [{
  badge: 'Nivel 1:',
  title: 'Preparación Lectora y Trazos',
  description: 'Actividades para desarrollar motricidad fina y reconocimiento de patrones. La base para preparar el cerebro antes de leer.',
  image: 'https://cdn.magicpatterns.com/uploads/edBiyGrzoA8Qjwvg3po23C/20260307_1643_Image_Generation_simple_compose_01kk4x60ckfrp8s7vxs3m5nrsq_(1).webp'
}, {
  badge: 'Nivel 2:',
  title: 'Asociación Sonido-Letra (Sílabas)',
  description: '¿Tu hijo reconoce sonidos? Actividades para asociar cada sonido con su letra correspondiente de forma natural.',
  image: 'https://cdn.magicpatterns.com/uploads/8rVvaxV9ZMASkBjqSRfH89/20260307_1644_Image_Generation_simple_compose_01kk4x83effk0spytqee72w5x8_(1).webp'
}, {
  badge: 'Nivel 3:',
  title: 'Construcción de Palabras',
  description: 'De sílabas a palabras completas. Ejercicios progresivos para formar palabras y empezar a leer con fluidez.',
  image: 'https://cdn.magicpatterns.com/uploads/wskm2fAKAkHE53fWtUxY5K/20260307_1645_Image_Generation_simple_compose_01kk4x9s1nfr1s7yy0gaq2y8gt_(1)_(1).webp'
}, {
  badge: 'Guía:',
  title: 'Guía Paso a Paso para Padres',
  description: 'Instrucciones claras para acompañar a tu hijo en cada etapa, incluso si no tenés experiencia docente.',
  image: 'https://cdn.magicpatterns.com/uploads/3gbyMErjaKHv715A5nbF1Q/20260307_1647_Image_Generation_simple_compose_01kk4xc5p0fm1a6ymq3kre0sw4_(1).webp'
}];
export function WhatIsIncluded() {
  return <section className="py-8 md:py-20 px-4 bg-white relative overflow-hidden" data-id="element-452">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-453">
        <FadeIn data-id="element-454">
          <div className="text-center mb-8 md:mb-16" data-id="element-455">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight mb-4 md:mb-6" data-id="element-456">
              ¿Qué incluye el Sistema?
            </h2>
            <div className="w-24 h-1 bg-accent-gold mx-auto rounded-full" data-id="element-457"></div>
          </div>
        </FadeIn>

        {/* Mobile: horizontal scroll carousel / Desktop: 4-column grid */}
        <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 hide-scrollbar md:grid md:grid-cols-4 md:gap-6 md:overflow-visible md:pb-0" data-id="element-458">
          {levels.map((level, idx) => <FadeIn key={idx} delay={idx * 0.1} className="snap-start shrink-0 w-[80%] md:w-auto" data-id="element-459">
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden h-full flex flex-col hover:shadow-md transition-shadow duration-300" data-id="element-460">
                {/* Product image */}
                <div className="aspect-[3/2] overflow-hidden border-b border-gray-100" data-id="element-461">
                  <img src={level.image} alt={level.title} className="w-full h-full object-cover" data-id="element-462" />
                </div>

                {/* Content */}
                <div className="p-3 md:p-6 flex flex-col flex-1 text-left" data-id="element-463">
                  {/* Badge */}
                  <div className="mb-2 md:mb-4" data-id="element-464">
                    <span className="bg-accent-gold text-white text-[10px] md:text-xs font-bold uppercase tracking-wider px-2 py-0.5 md:px-2.5 md:py-1 rounded-md" data-id="element-465">
                      {level.badge}
                    </span>
                  </div>

                  {/* Title */}
                  <h3 className="text-sm md:text-lg font-semibold text-gray-900 mb-1.5 md:mb-2 leading-snug" data-id="element-466">
                    {level.title}
                  </h3>

                  {/* Description */}
                  <p className="text-gray-500 text-xs md:text-sm leading-relaxed flex-1" data-id="element-467">
                    {level.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}